export class ToCreatePolicy {
    constructor(
        public cacheId: string,
        public temporaryQuoteId: string,
        public brokerID: string
    ){}
}